import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class EndpointPrefixInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('http://') || request.url.startsWith('https://')) {
      return next.handle(request);
    }
    request = request.clone({
      url: '/api/v1/' + request.url
    });

    return next.handle(request);
  }
}
